module.exports = __webpack_public_path__ + "partylineManage/img/tvuLogo.790ff04b.png";